import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DefineAssetComponent } from "../../client/define-asset/define-asset.component";
import { DefineEboilerComponent } from '../define-eboiler/define-eboiler.component';
import {MatRadioModule} from '@angular/material/radio';
import { ActivatedRoute, Router } from '@angular/router';
import { Inject } from '@angular/core';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { DefineOvenComponent } from '../../oven-system/define-oven/define-oven.component';
@Component({
  selector: 'app-select-sub-system',
  templateUrl: './select-sub-system.component.html',
  styleUrls: ['./select-sub-system.component.scss'],
  standalone: true,
  imports: [ MatRadioModule,FormsModule,NgbModule,CommonModule,MatButtonModule,DefineOvenComponent]
})
export class SelectSubSystemComponent implements OnInit {
  public selectedOption: any;
  public selectedPowertrainOption: any='emsaver';
  public clientId:any;
  public tabID_1: any;
  public tabID_3: any;
  public tabID_2: any;
  public tabID_4: any;
  public productionKey = BaseUrlConstantsService.PRODUCTION_KEY;
  public tabID_7: any;
  public product_type_list = {
    "Rotating Assets"	:1,
    "boiler":2,
    "energy_meter":3,
    "Transformers": 4,
    "Cylinders": 5,
    "Thermal":6,
	  "oven":7 
  }
  constructor(public dialogRef: MatDialogRef<SelectSubSystemComponent>,
    public dialog: MatDialog,
    public router: Router,
    @Inject(MAT_DIALOG_DATA)
    public data: any,) {
      if(localStorage.getItem('role') === 'CLIENT'){
        this.clientId = localStorage.getItem('user_id');
      }else{
        this.clientId = localStorage.getItem('admin_client_id');
      }
      console.log(data,'dataaaaaaaa');
      if(this.data.type === 'select system'){
        this.tabID_1 =  data.dataKey.tabID_1,
        this.tabID_2 = data.dataKey.tabID_4,
        this.tabID_3  = data.dataKey.tabID_3,
        this.tabID_4  = data.dataKey.tabID_2,
        this.tabID_7 = data.dataKey.tabID_7
      }
   }

  ngOnInit(): void {
  }

  onClickContinue(){
    this.dialogRef.close();
    if(this.selectedOption === 'rotating_asset'){
      const dialogRef1 = this.dialog.open(DefineAssetComponent, {
        width: "500px",
        maxWidth: "100%",
        height: "520px",
        disableClose: true,
        panelClass: "custom-modalbox",
        data: {},
      });
      dialogRef1.afterClosed().subscribe((res) => {});
    }else if(this.selectedOption === 'boiler'){
      const dialogBoilerRef = this.dialog.open(DefineEboilerComponent, {
        width:"900px",
        maxWidth: "100%",
        height: "520px",
        disableClose: true,
        panelClass: "custom-modalbox",
        data : {client_id: this.clientId,
          product_type_id: this.product_type_list[this.selectedOption]
        }
      });
      dialogBoilerRef.afterClosed().subscribe((res) =>{});
    }else if(this.selectedOption === 'energy_meter'){
      this.router.navigate(['energy-meter-configuration']);
    }else if(this.selectedOption === 'powertrain'){
         const dialogBoilerRef = this.dialog.open(SelectSubSystemComponent, {
        width:"900px",
        maxWidth: "100%",
        height: "520px",
        disableClose: true,
        panelClass: "custom-modalbox",
        data : {type:'select-powertrain-system',}
      });
      dialogBoilerRef.afterClosed().subscribe((res) =>{
        if(res && res.selectedPowertrainOption){
          if(res.selectedPowertrainOption ==='emsaver'){
            this.router.navigate(['powertrain-create'],{queryParams:{client_id:this.clientId},skipLocationChange:true});
          }else if(res.selectedPowertrainOption ==='piezeo'){
            this.router.navigate(['piezeo-create'],{queryParams:{client_id:this.clientId},skipLocationChange:true});
          }
        }
      });
        //  this.router.navigate(['powertrain-create']);
    }else if(this.selectedOption === 'cyclinder'){
      this.router.navigate(['cyclinder-create-form'],{queryParams:{client_id:this.clientId},skipLocationChange:true});
    }else if(this.selectedOption === 'piezeo'){
      this.router.navigate(['piezeo-create'],{queryParams:{client_id:this.clientId},skipLocationChange:true});
      // this.router.navigate(['piezeo-create-form'],{queryParams:{client_id:this.clientId},skipLocationChange:true});
    }
    else if(this.selectedOption === 'oven'){
      const dialogBoilerRef = this.dialog.open(DefineOvenComponent, {
        width:"900px",
        maxWidth: "100%",
        height: "520px",
        panelClass: "custom-modalbox",
        disableClose: true,
        data : {client_id: this.clientId,
          product_type_id: this.product_type_list[this.selectedOption]
        }
      });
      dialogBoilerRef.afterClosed().subscribe((res) =>{});
    }
  }
  onclickclose() {
    this.dialogRef.close();
  }

  onPowertrainSelectionComplete(){
    this.dialogRef.close({selectedPowertrainOption:this.selectedPowertrainOption});
  }
  onClosePowertrainDialog(){
    this.dialogRef.close({});
  }
}
